
export type ProductCategory = "session" | "still" | "sparkling";

type ExciseCategory = {
    description: string;
    rate_per_100l_eur: number;
    applies_to: string[];
  };
  
  type ExciseDuty = {
    country: string;
    year: string;
    excise_duty: {
      still_wine: ExciseCategory;
      sparkling_wine: ExciseCategory;
    };
    notes: string[];
  };

  export const exciseDutyInfoNL = {
    session: {
      abvLimit: 8.5,
      ratePer100L: 47.95,
      description: "Still or sparkling wine with alcohol content up to 8.5% ABV",
    },
    still: {
      abvLimit: 15,
      ratePer100L: 95.69,
      description: "Still or sparkling wine with alcohol content over 8.5% ABV",
    },
    sparkling: {
      abvLimit: 15,
      ratePer100L: 95.69,
      description: "Still or sparkling wine with alcohol content over 8.5% ABV",
    },
    intermediate: {
      abvLimit: 15,
      ratePer100L: 114.85,
      description: "Intermediate products (e.g., fortified wines) up to 15% ABV",
    },
    intermediateHigh: {
      abvLimit: 22,
      ratePer100L: 161.80,
      description: "Intermediate products over 15% ABV",
    },
  };
  
  

 
  
  export function calculateExciseDuty(
    volumeLiters: number,
    abv: number,
    isSparkling: boolean
  ): number {
    let category: ProductCategory;
  
    if (abv <= 6) {
      category = "session";
    } else if (isSparkling) {
      category = "sparkling";
    } else {
      category = "still";
    }
  
    const rate = exciseDutyInfoNL[category].ratePer100L;
    const dutyRaw = (volumeLiters / 100) * rate;
    return Number(dutyRaw.toFixed(2)); // normal rounding to 2 decimals
  }
  
  